import type { SupraSystemSubscriptionDoc } from '@bb/domain/dist/schemas';
import type { UserWithPopulatedOrg } from '@bb/users';
import axios from 'axios';

type SingleResponse = {
  requestOwnerMappingId: string;
  user: UserWithPopulatedOrg;
  subscription: SupraSystemSubscriptionDoc;
};
type MultiResponse = {
  requestOwnerMappingId: string;
  users: UserWithPopulatedOrg[];
  subscriptions: SupraSystemSubscriptionDoc[];
};

export type IGetSubscriptionByKeySerialNumber = SingleResponse | MultiResponse;

// type guard to check if the response is MultiResponse, if isLinkAccountPhase2Enabled is enabled, then the response will be MultiResponse,
// otherwise it will be SingleResponse
export const isMultiResponse = (
  data: IGetSubscriptionByKeySerialNumber,
): data is MultiResponse => (
    'users' in data &&
    'subscriptions' in data &&
    Array.isArray(data.users) &&
    Array.isArray(data.subscriptions)
  );

const getSubscriptionByKeySerialNumber = async (
  keySerialNumber: number,
  pin: string,
) => {
  const { data } = await axios.get<IGetSubscriptionByKeySerialNumber>(
    `/supra/subscription_by_sn/${keySerialNumber}?pin=${pin}`,
  );

  return data;
};

export default getSubscriptionByKeySerialNumber;
